function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { buttonReset } from "../../../utils/css/reset";
export var defaultStyles = {
    container: {
        base: {}
    },
    item: {
        base: {},
        firstButton: {},
        lastButton: {},
        hover: {},
        active: {},
        focus: {},
        focusVisible: {},
        disabled: {},
        icon: {
            base: {},
            alignStart: {},
            alignEnd: {},
            iconOnly: {}
        },
        iconOnly: {},
        autoWidth: {},
        size: {
            s: {},
            m: {},
            l: {}
        }
    }
};
var buildStyle = function(theme, param) {
    var start = param.start, end = param.end;
    var animation = theme.animation, font = theme.font, depth = theme.depth, borderColor = theme.borderColor, size = theme.size, backgroundColor = theme.backgroundColor;
    var _obj, _obj1;
    return {
        container: {
            base: {
                display: 'flex'
            }
        },
        item: {
            base: _objectSpread({}, buttonReset(), _defineProperty({
                boxSizing: 'border-box',
                border: "".concat(size.border.base, "px solid"),
                borderColor: borderColor.soft,
                background: backgroundColor.neutral.base,
                fontFamily: font.base.family,
                fontWeight: font.base.weight.regular,
                color: font.color.soft,
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: "all ".concat(animation.duration[100], " ").concat(animation.productive.easeInOut.easing),
                cursor: 'pointer',
                svg: {
                    fill: font.color.soft,
                    transition: "all ".concat(animation.duration[100], " ").concat(animation.productive.easeInOut.easing)
                }
            }, start.margin, "-".concat(size.border.base, "px"))),
            firstButton: (_obj = {}, _defineProperty(_obj, start.margin, 0), _defineProperty(_obj, start.borderTopRadius, size.border.radius.fiveX), _defineProperty(_obj, start.borderBottomRadius, size.border.radius.fiveX), _obj),
            lastButton: (_obj1 = {}, _defineProperty(_obj1, end.borderTopRadius, size.border.radius.fiveX), _defineProperty(_obj1, end.borderBottomRadius, size.border.radius.fiveX), _obj1),
            hover: {
                background: backgroundColor.clickNeutral.surface,
                color: font.color.base,
                svg: {
                    fill: font.color.base
                }
            },
            active: {
                background: backgroundColor.selectList.active,
                color: font.color.brand.active,
                cursor: 'default',
                svg: {
                    fill: font.color.brand.active
                }
            },
            focus: {},
            focusVisible: {
                outline: 0,
                boxShadow: "0 0 0 2px ".concat(borderColor.interactive.focus),
                borderColor: borderColor.interactive.base
            },
            disabled: {
                cursor: 'default',
                opacity: depth.opacity.light
            },
            size: {
                s: {
                    fontSize: font.base.size.s,
                    padding: '8px 16px',
                    height: 32,
                    minWidth: 96
                },
                m: {
                    height: 40,
                    padding: '8px 16px',
                    fontSize: font.base.size.m,
                    minWidth: 112
                },
                l: {
                    height: 44,
                    padding: '8px 16px',
                    fontSize: font.base.size.m,
                    minWidth: 128
                }
            },
            iconOnly: {
                padding: '8px'
            },
            autoWidth: {
                minWidth: 'unset'
            },
            icon: {
                base: {
                    display: 'flex',
                    justifyContent: 'center',
                    alignContent: 'center'
                },
                alignStart: _defineProperty({}, end.padding, '8px'),
                alignEnd: _defineProperty({}, start.padding, '8px'),
                iconOnly: {
                    padding: 0
                }
            }
        }
    };
};
export default buildStyle;
